import type { Novidade } from './tipos';

/** Fase 2 (W19): inadimplência derivada do Contas, código do parceiro e os arremates da ficha (Pix, endereço, e-mail repetido). */
export const novidadeFichaPessoas: Novidade = {
  id: '2026-10-05-ficha-pessoas',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: 'cadastros',
  permissao: 'cadastros.ver',
  textos: {
    pt: {
      titulo: 'Inadimplência na ficha, código do parceiro e ficha mais rápida',
      resumo: 'Quem tem fatura vencida ganha a marca Inadimplente, cada cadastro pode ter um código e a ficha confere Pix e e-mail.',
      passos: [
        'Na lista e na ficha, a marca Inadimplente aparece sozinha para quem tem fatura vencida em aberto, com os dias e o valor.',
        'Ao emitir uma fatura para um cliente inadimplente, o sistema avisa, sem bloquear a emissão.',
        'Use o campo Código para o código do sistema antigo: ele aparece na lista, entra na busca e na importação.',
        'A chave Pix ganha a máscara do tipo escolhido, o endereço novo copia o principal e o e-mail repetido é avisado.',
      ],
    },
    en: {
      titulo: 'Overdue payments on the record, partner code and a quicker record',
      resumo: 'Anyone with an overdue invoice gets the Overdue mark, each record can have a code and the record checks Pix and e-mail.',
      passos: [
        'In the list and on the record, the Overdue mark shows up by itself for anyone with an open overdue invoice, with days and amount.',
        'When you issue an invoice to an overdue customer, the system warns you without blocking it.',
        'Use the Code field for the code from the old system: it shows in the list and works in search and import.',
        'The Pix key follows the mask of the chosen type, a new address copies the main one and a repeated e-mail is flagged.',
      ],
    },
    es: {
      titulo: 'Morosidad en la ficha, código del socio y una ficha más ágil',
      resumo: 'Quien tiene una factura vencida recibe la marca Moroso, cada registro puede tener un código y la ficha revisa Pix y correo.',
      passos: [
        'En la lista y en la ficha, la marca Moroso aparece sola para quien tiene una factura vencida abierta, con los días y el valor.',
        'Al emitir una factura a un cliente moroso, el sistema avisa sin bloquear la emisión.',
        'Usa el campo Código para el código del sistema anterior: aparece en la lista y funciona en la búsqueda y la importación.',
        'La clave Pix sigue la máscara del tipo elegido, la dirección nueva copia la principal y el correo repetido se avisa.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-ficha-pessoas/ficha.webp', '/novidades/2026-10-05-ficha-pessoas/fatura.webp', null, null],
  treinamento: { curso: 'novidades' },
  rota: '/cadastros/cadastros/pessoas',
};
